import {Alert, Anchor, Box, Button, createStyles, Flex, Image, Stack, Text} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as net from 'util/Net';

const useStyles = createStyles((theme) => ({
  card: {
    width: 380,
    maxWidth: '100%',
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    padding: theme.spacing.xl,
    boxShadow:
      '0px 1px 1.5px rgba(0, 0, 0, 0.05), 0px 7px 3.5px rgba(0, 0, 0, 0.04), 0px 10px 7.5px rgba(0, 0, 0, 0.1)',
  },
  setupButton: {
    height: 'auto',
    paddingTop: theme.spacing.md,
    paddingBottom: theme.spacing.md,
    '&:hover': {
      color: theme.white,
      backgroundColor: theme.colors.blue[9],
      textDecoration: 'none',
    },
  },
}));

function AuthCard({children}: {children: React.ReactNode}): JSX.Element {
  const {classes} = useStyles();
  return (
    <Box id="auth" className="auth-v2" h="100%">
      <Flex className="container" justify="center" align="center" h="100%">
        <Box className={classes.card}>{children}</Box>
      </Flex>
    </Box>
  );
}

export interface MfaRequiredPageProps {
  customRequiredMessage?: string | null;
  isSignedIn?: boolean;
}

export default function MfaRequiredPage(props: MfaRequiredPageProps): JSX.Element {
  const {classes} = useStyles();
  const onSignInToDifferentAccount = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    // /signout is a POST-only route that clears the session and redirects to /signin.
    net.submitCSRFForm('POST', '/signout');
  };
  return (
    <AuthCard>
      <Stack spacing="lg" align="center">
        <Image
          width={240}
          height={52}
          src="/static/img/bioblue_wordmark_500.png"
          className="brand-benchling-logo"
          alt="Benchling"
          fit="contain"
        />
        <Alert
          variant="warning"
          icon={<BenchlingIcon icon="warning" />}
          title="Your admin requires MFA on all accounts"
          w="100%"
        >
          You’ll need to set up multi-factor authentication to sign into your account.
        </Alert>
        {props.customRequiredMessage != null && props.customRequiredMessage.trim() !== '' && (
          <Stack spacing={0} w="100%">
            <Text size="sm" weight={600}>
              Message from your Admin:
            </Text>
            <Text size="xs" fs="italic">
              {props.customRequiredMessage}
            </Text>
          </Stack>
        )}
        <Stack spacing="sm" align="center" w="100%">
          <Button w="100%" component="a" href="/settings/mfa" className={classes.setupButton}>
            Set up multi-factor authentication
          </Button>
          <Anchor
            href="/signin"
            size="xs"
            onClick={props.isSignedIn ? onSignInToDifferentAccount : undefined}
          >
            Sign in to a different account
          </Anchor>
        </Stack>
      </Stack>
    </AuthCard>
  );
}
